import React, { Component } from 'react';
import { Alert, Collapse, Modal, Row, Col } from 'react-bootstrap';
import { Form, Input, Textarea } from 'formsy-react-components';
import { withRouter } from "react-router-dom";
import Parse from 'parse'

import ReactGA from "react-ga";
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';

import { Center, ImageSection, LogeButton, Icon, Black, ModalHeading } from '../../GeneralStyle'

import headerImage from '../../../images/modal/tl_header_bewerbung.jpg';
import styled from 'styled-components'

const STATE = { LOADING: 'loading', ERROR: 'error', DEFAULT: 'default', SUCCESS: 'success' }

@inject('partnerInformationStore')
@observer
class UpdatePartnerContactModal extends Component {
  constructor(props) {
    super(props)
    const selectedIndustries = props.partner && props.partner.industries ? this.props.partnerInformationStore.industries.filter(industry => {
      return props.partner.industries.find(i => i === industry.id)
    }) : []
    this.state = {
      showModal: false,
      state: STATE.DEFAULT,
      selectedIndustries,
      partner: props.partner,
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partner !== this.props.partner)
      this.setState({ partner: this.props.partner })
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  openModal = () => {
    this.setState({ showModal: true });
  }

  onSubmit = async (data) => {
    try {
      data.postcode = Number(data.postcode)
      data.tags = data.tags && data.tags.split(",").map(s => s.trim());
      data.industries = this.state.selectedIndustries.map(industry => industry.id)
      this.setState({state: STATE.LOADING, partner: data})
      const res = await Parse.Cloud.run("updatePartnerInformation", data)
      this.closeModal()
      this.setState({state: STATE})
      this.props.partnerInformationStore.loadPartnerFromShortname(this.props.partner.shortname)
      this.props.partnerInformationStore.checkRequiredInformation()
    } catch (e) {
      this.setState({state: STATE.ERROR})
      console.error(e);
    }
  }


  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.'

    const partner = this.state.partner

    const notSelectedIndustries = this.props.partnerInformationStore.industries.filter(industry => this.state.selectedIndustries.indexOf(industry) < 0)

    const DataForm = () => {
      return (
        <Form
          onSubmit={this.onSubmit}
          layout={'vertical'}
          validateOnSubmit={true}
          validatePristine={false}
          disabled={ this.state.state === STATE.LOADING }
          style={{color: 'black'}}
          className="partner-modal-form"
        >
          <Col sm={12}>
            <Input
              name="name"
              value={ partner.name }
              // onChange={e => this.setState({partner: { name: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Firmenname*"
              required

            />
          </Col>
          <Col sm={6}>
            <Input
              name="phone"
              value={ partner.phone }
              // onChange={e => this.setState({partner: { phone: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Telefonnummer*"
              required
            />
          </Col>
          <Col sm={6}>
            <Input
              name="email"
              value={ partner.email }
              // onChange={e => this.setState({partner: { email: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Email*"
              required
            />
          </Col>
          <Col sm={6}>
            <Input
              name="website"
              value={ partner.website }
              // onChange={e => this.setState({partner: { website: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Website*"
              required
            />
          </Col>
          <Col sm={6}>
            <Input
              name="uidNumber"
              value={ partner.uidNumber }
              // onChange={e => this.setState({partner: { uidNumber: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="UID-Nummer*"
              required
            />
          </Col>
          <Col sm={12}>
            <Input
              name="street"
              value={ partner.street }
              // onChange={e => this.setState({partner: { street: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Straße- und Hausnummer*"
              required
            />
          </Col>
          <Col sm={8}>
            <Input
              name="location"
              value={ partner.location }
              // onChange={e => this.setState({partner: { location: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Stadt*"
              required
            />
          </Col>
          <Col sm={4}>
            <Input
              name="postcode"
              value={ partner.postcode }
              // onChange={e => this.setState({partner: { postcode: e, ...partner }})}
              type="number"
              validationErrors={{ isDefaultRequiredValue }}
              label="PLZ*"
              required
            />
          </Col>
          <Col sm={12}>
            <SelectedTitle>
              <label>Branchen*</label>
              <span>maximal 3 Branchen auswählen</span>
            </SelectedTitle>
            <div style={{minHeight: 50}}>
            {
              this.state.selectedIndustries.map(industry => {

                const remove = () => {
                  const selectedIndustries = [...this.state.selectedIndustries]
                  selectedIndustries.splice(selectedIndustries.indexOf(industry), 1)
                  this.setState({ selectedIndustries })
                }

                return (<SelectedIndustryItem onClick={remove}>{ industry.name }</SelectedIndustryItem>)
              }
              )
            }
            </div>
            <SelectedBorder />
          </Col>
          <Col sm={12} style={{paddingBottom: 10}}>
            {

              notSelectedIndustries.map(industry =>
                <IndustryItem onClick={() => this.state.selectedIndustries.length <= 2 && this.setState({selectedIndustries: [...this.state.selectedIndustries, industry]})}>{ industry.name }</IndustryItem>
              )
            }
          </Col>
          <Col sm={12}>
            <Textarea
              name="description"
              value={ partner.description }
              // onChange={e => { this.setState({partner: { description: e, ...partner } }) }}
              validationErrors={{ isDefaultRequiredValue }}
              label="Firmen Beschreibung*"
              required
              style={{ height: 'auto'}}
            />
          </Col>
          <Col sm={12}>
            <Textarea
              name="deals"
              value={ partner.deals }
              // onChange={e => this.setState({partner: { deals: e, ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Firmen Angebote"
            />
          </Col>
          <Col sm={12}>
            <Input
              name="tags"
              value={ partner.tags && partner.tags.join(", ") }
              // onChange={e => this.setState({partner: { tags: e.target.value.split(",").map(s => s.trim()), ...partner }})}
              type="text"
              validationErrors={{ isDefaultRequiredValue }}
              label="Keywords zum Service der Firma (mit Beistrichen getrennt)"
            />
          </Col>
          { this.state.state === STATE.ERROR && <Col sm={12} style={{color: "red", textAlign: "center", paddingTop: 20}}>Es ist ein Fehler aufgetreten.</Col> }
          <Center marginTop={60} marginBottom={30}>
            <LogeButton
              hoverFontColor={"white"}
              type="submit"
              style={{ marginTop: 30}}
              disabled={ this.state.state === STATE.LOADING }
            >
              Daten speichern
            </LogeButton>
          </Center>
        </Form>
      )
    }

    return (

      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={ headerImage }>
          <Modal.Header closeButton>
            <Modal.Title>
              <div><ModalHeading>Allgemeine Firmendaten</ModalHeading></div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          <DataForm />
        </Modal.Body>
      </Modal>
    );
  }
}

const IndustryItem = styled.div`
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid #999;
  display: inline-block;
  color: #999;
  cursor: pointer;
  transition: all .25s ease-in-out;
  margin: 5px 10px 5px 0;
  &:hover {
    background: #999;
    color: white;
  }
  @media (max-width: 900px){
    padding: 5px 10px;
  }
`

const SelectedBorder = styled.div`
  border-bottom: 1px solid #999;
  margin-bottom: 5px;
`

const SelectedTitle = styled.div`
  display: flex;
  justify-content: space-between;
  label {
    font-size: 1em;
    color: black;
    font-weight: 400;
    marginBottom: 5px;
  }
  span {
    color: #999;
  }
`

const SelectedIndustryItem = styled.div`
  padding: 10px 20px;
  border-radius: 5px;
  border: 1px solid rgb(218,183,119);
  display: inline-block;
  color: rgb(218,183,119);
  cursor: pointer;
  transition: all .25s ease-in-out;
  margin: 5px 10px 5px 0;
  &:hover {
    background: rgb(218,183,119);
    color: white;
  }
  @media (max-width: 900px){
    padding: 5px 10px;
  }
`

export default withRouter(UpdatePartnerContactModal)



// WEBPACK FOOTER //
// /src/components/partner/modals/UpdatePartnerInformationModal.js